<template>
  <div class="page">
    <div class="page_title">网点申报列表</div>
    <div class="page_main">
      <div class="handle_group">
        <div class="handle" @click="goAddMaterial">
          <i class="el-icon-document-add"></i>
          新增网点申报信息
        </div>
        <div class="center_line"></div>
        <div class="handle" @click="refresh">
          <i class="el-icon-refresh-right"></i>
          刷新
        </div>
      </div>
      <div class="table_container">
        <el-table
          :data="posList"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            align="center"
            label="日期"
            prop="modTime"
            width="100">
          </el-table-column>
          <el-table-column
            align="center"
            label="地理位置"
            prop="addressText"
            width="120">
          </el-table-column>
          <el-table-column
            align="center"
            label="资料完整度"
            prop="completeness"
            width="120">
          </el-table-column>
          <el-table-column
            align="center"
            label="网点状态"
            prop="status"
            width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="orange-text">待审核</span>
              <span v-else-if="scope.row.status == 1" class="green-text">已通过</span>
              <span v-else-if="scope.row.status == 2" class="red-text">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <button class="button modify" @click="queryMaterial(scope.row)">修改</button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="loadMore" class="loadMore">
          <van-loading color="#07c160" size="24"/>
          加载更多
        </div>
        <div v-else class="loadMore">已加载所有网点申报资料</div>
      </div>
    </div>
  </div>
</template>

<script>

import {userQueryUploadPosApply} from "../api";

export default {
  name: "material_declarationList",
  data() {
    return {
      posList: [],
      loadMore: true,

    }
  },
  mounted() {
    this.getmateriaList()
  },
  methods: {
    getmateriaList() {
      if (this.loadMore) {
        let params = {
          userAccount: sessionStorage.getItem('openid'),
        }
        userQueryUploadPosApply(params).then(res => {
          console.log(res)
          if (!res.data._embedded.myUrls) {
            console.log('已加载所有网点申报');
            this.loadMore = false;
          } else {
            let data = res.data._embedded.myUrls;
            this.loadMore = false;
            this.posList = data.reverse();
            for (const item of this.posList) {
              const completeness = this.completenessPercentage(item);
              this.$set(item, "completeness", completeness)
            }
          }
        }).catch(error => {
          alert(`异常${error}`);
        })
      }
    },


    //查看网点上传资料完整度的方法
    completenessPercentage(item) {
      let nonEmptyCount = 0;
      const totalProperties = Object.keys(item).length;
      for (const key in item) {
        if (item[key] && item[key] !== "[]") {
          nonEmptyCount++;
        }
      }
      const completenessPercentage = Math.round((nonEmptyCount / totalProperties) * 100);
      return completenessPercentage + "%";
    },

    //修改按钮，查询网点现场资料具体信息
    queryMaterial(item) {
      console.log('修改');
      this.$router.push({
        name: 'material_collection',
        params: {
          object: item,
        }
      })
    },
    //上传新的网点采集信息
    goAddMaterial() {
      console.log('新增网点申报列表');
      this.$router.push('/material_collection')
    },
    // 刷新
    refresh() {
      this.page = 1;
      this.posList = [];
      this.loadMore = true;
      this.getmateriaList();
      this.$notify({
        icon: 'success',
        message: '刷新成功'
      })
    },
  }
}


</script>

<style scoped src="../css/posList.css">

</style>



// WEBPACK FOOTER //
// src/views/material_declarationList.vue